import { render, staticRenderFns } from "./import-batch-retire-case.vue?vue&type=template&id=10fe1f5c&scoped=true"
import script from "./import-batch-retire-case.vue?vue&type=script&lang=ts"
export * from "./import-batch-retire-case.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fe1f5c",
  null
  
)

export default component.exports